// FIFO task queue for serialized storage mutations.
//
// Concurrent async mutations against the same record (e.g. sealing the roster
// into the vault) complete in arbitrary order when fired freely: a slow first
// write can land after a later one and clobber fresher state. Chaining every
// mutation through one queue makes completions follow issuance order, so the
// latest write always wins.
export type TaskQueue = <T>(task: () => Promise<T>) => Promise<T>;

export function createTaskQueue(): TaskQueue {
  let tail: Promise<unknown> = Promise.resolve();
  return <T>(task: () => Promise<T>): Promise<T> => {
    const next = tail.then(task, task);
    // A rejection must not wedge the chain: the caller still sees it via the
    // returned promise, but later tasks keep running.
    tail = next.catch(() => {});
    return next;
  };
}
